import React, { PureComponent } from 'react';
import styled from 'styled-components';

import pxInRem from 'shared/helpers/styled-components/remHelper';
import { Symbol } from 'shared/components/presentational/Map';
import Icon from 'shared/components/presentational/Icons';
import { FONT_FAMILIES, FONT_WEIGHTS } from 'shared/constants/theme';

const Wrapper = styled.li`
  background-color: ${props =>
    props.isSelected ? 'var(--surface-secondary)' : 'var(--surface-primary)'};
  border-bottom: 1px solid var(--surface-border-light);
  display: flex;
  flex-direction: row;
  padding: 20px 25px 20px 40px;
  cursor: ${props => (props.onClick ? 'pointer' : 'normal')};
`;

const StyledSymbol = styled(Symbol)`
  color: ${props =>
    props.isSelected ? 'var(--icons-secondary)' : 'var(--icons-default)'};
  flex-basis: 24px;
  width: 24px;
  min-width: 24px;
  height: 28px;
  margin-right: 25px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
`;

const Title = styled.h3`
  font-family: ${FONT_FAMILIES.base};
  font-weight: ${FONT_WEIGHTS.bold};
  font-size: ${pxInRem(14)};
  margin: 0 0 20px 0;
`;

const Description = styled.p`
  font-family: ${FONT_FAMILIES.base};
  color: var(--text-light);
  margin: 0;
`;

const IconWrapper = styled.div`
  color: var(--icons-default);
  flex-basis: 40px;
  min-width: 40px;
  align-self: center;
  font-size: 20px;
  text-align: center;
`;

export default class ListItem extends PureComponent {
  static defaultProps = {
    isSelected: false
  };

  handleClick = () => {
    const { onClick, shop } = this.props;
    onClick(shop);
  };

  render() {
    const { isSelected, shop } = this.props;
    const { name, type, city } = shop;
    return (
      <Wrapper
        isSelected={isSelected}
        onClick={this.handleClick}
        itemScope
        itemType="http://schema.org/Store"
      >
        <StyledSymbol type={shop.type} isSelected={isSelected} />
        <Content>
          <Title>
            <span itemProp="name">{name}</span>
            <br />
            <span itemProp="description">{type}</span>
          </Title>
          <Description
            itemProp="address"
            itemScope
            itemType="http://schema.org/PostalAddress"
          >
            <span itemProp="addressLocality">{city}</span>
          </Description>
        </Content>
        <IconWrapper>
          <Icon name="ArrowRight" />
        </IconWrapper>
      </Wrapper>
    );
  }
}
